/** Fold accents and case for dropdown/filter substring search (e.g. "LEGA" matches "Léga"). */
export function foldSearchText(value: string): string {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

export function includesFoldedSearch(haystack: string, query: string): boolean {
  const foldedQuery = foldSearchText(query);
  if (!foldedQuery) {
    return true;
  }
  return foldSearchText(haystack).includes(foldedQuery);
}
